var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable react/function-component-definition,no-else-return */
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableContainer from '@mui/material/TableContainer';
import Button from '@mui/material/Button';
import TableCell from '@mui/material/TableCell';
import DeleteIcon from '@mui/icons-material/Delete';
import ShieldIcon from '@mui/icons-material/Shield';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import TableBody from '@mui/material/TableBody';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { addPlayerToMatch, createPlayer, loadPlayersInMatch, removePlayerFromMatch, setPaymentMethod, setPlayerImmunity, loadPayersInMatch, updatePlayerNames, setPlayersOrder, } from '../../../api';
import { EPaymentType } from '../../../types';
import { TableHeaderCellNew } from '../../atoms/Table/TableHeaderCell';
import { TableBodyCellNew } from '../../atoms/Table/TableBodyCell';
import { Delimiter } from '../../atoms/Delimiter';
import { ModalNew } from '../../atoms/Modal/Modal';
import { AjustPlayersOrder } from '../AjustPlayersOrder/AjustPlayersOrder';
import { useAsyncExecAction } from '../../../hooks/useAsyncExecAction';
import { TableBodyRowNew } from '../../atoms/Table/TableBodyRow/TableBodyRow';
import { AlertsNew } from '../../molecules/Alerts';
import { Payment } from '../../molecules/Payment';
import { useErrorHandler } from '../../../hooks/useErrorHandler';
import { ImmunityReason } from '../../molecules/ImmunityReason';
import { PlayerNameEditing } from '../../molecules/PlayerNameEditing';
import { TableSkeleton } from '../../atoms/Skeleton';
const TableCellNumberHeader = styled(TableHeaderCellNew) `
  padding-left: 16px;
  width: 86px;
`;
const TableCellNameHeader = styled(TableHeaderCellNew) `
  width: 152px;
`;
const TableCellNickHeader = styled(TableHeaderCellNew) `
  width: 182px;
`;
const TableCellGamesHeader = styled(TableHeaderCellNew) `
  width: 92px;
`;
const TableCellPayHeader = styled(TableHeaderCellNew) `
  width: 188px;
  padding-right: 16px;
`;
const TBRow = styled(TableBodyRowNew) `
  font-weight: ${({ shadow }) => (shadow ? '500' : '300')};
  background: ${({ shadow }) => (shadow ? '#2AB2FF' : 'rgba(255, 255, 255, 0.1)')};
  &:nth-child(2n) {
    background: ${({ shadow }) => (shadow ? '#2AB2FF' : 'rgba(255, 255, 255, 0.2)')};
  }
`;
const TBCell = styled(TableBodyCellNew) ``;
const TableCellNumberContainer = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
const TableCellNumberBody = styled(TBCell) `
  padding-left: 16px;
  width: 86px;
`;
const TableCellNameBody = styled(TBCell) `
  width: 152px;
`;
const TableCellNickBody = styled(TBCell) `
  width: 182px;
`;
const TableCellGamesBody = styled(TBCell) `
  width: 92px;
`;
const TableCellPayBody = styled(TBCell) `
  width: 188px;
  padding-right: 16px;
`;
const TableCellContainer = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px;
`;
const Title = styled.div `
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  color: #000;
`;
const TableHeaderContainer = styled.div `
  display: flex;
  justify-content: space-between;
`;
const TableHeader = styled.div `
  display: flex;
  align-items: center;
  min-height: 26px;
`;
// const TableBody = styled(TableBodyWithScrollNew)`
//   max-height: 45vh;
// `
const PlayerButtonImg = styled.img `
  width: 28px;
  height: 28px;
  cursor: pointer;
`;
const ShieldImg = styled.img `
  width: 12px;
  height: 14px;
  margin-right: 15px;
`;
const NoPlayersImg = styled.img `
  width: 550px;
  height: 290px;
  align-self: center;
`;
export const MatchPlayers = ({ forceAdjustWindowOpened, matchId, changed, setChanged, orderSet, setDisabled, unknownSourcePlayerIds = [], }) => {
    const [adjustOrder, setAdjustOrder] = useState(false);
    const [players, setPlayers] = useState([]);
    const [payers, setPayers] = useState([]);
    const [selectedPlayers, setSelectedPlayers] = useState([]);
    const [previousSelectedPlayers, setPreviousSelectedPlayers] = useState([]);
    const [shieldCancel, setShieldCancel] = useState(false);
    const [playersCancel, setPlayersCancel] = useState(false);
    const [playersChanged, setPlayersChanged] = useState(false);
    const [showImmunityPopup, setShowImmunityPopup] = useState(false);
    const [isEditingPlayerPopupShown, setIsEditingPlayerPopupShown] = useState(false);
    const [editingPlayer, setEditingPlayer] = useState(null);
    const [immunityReason, setImmunityReason] = useState(null);
    const [infoAlert, setInfoAlert] = useState({
        message: '',
        visible: false,
        setCancel: null,
    });
    const { execAsyncAction } = useAsyncExecAction();
    const { errorHandler } = useErrorHandler();
    const [dragLoading, setDragLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const playersAction = () => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield loadPlayersInMatch(matchId || '');
        setPlayers(response);
        setIsLoading(false);
    });
    const payersAction = () => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield loadPayersInMatch(matchId || '');
        setPayers(response);
    });
    const getPlayers = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!matchId)
            return;
        execAsyncAction({ action: playersAction });
    });
    const getPayers = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!matchId)
            return;
        execAsyncAction({ action: payersAction });
    });
    useEffect(() => {
        if (!matchId)
            return;
        const intervalId = setInterval(() => {
            getPlayers();
        }, 50000); // Обновляем каждые 10 секунд
        return () => clearInterval(intervalId); // Очищаем интервал при размонтировании
    }, [matchId]);
    const getRemovePlayerAction = (id) => function () {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield removePlayerFromMatch(id);
            // console.log('AddPlayersToMatch removePlayer', result)
        });
    };
    const removePlayer = (id) => __awaiter(void 0, void 0, void 0, function* () {
        yield execAsyncAction({ action: getRemovePlayerAction(id) });
    });
    // eslint-disable-next-line no-shadow
    const onRemovePlayerClick = (players) => __awaiter(void 0, void 0, void 0, function* () {
        // eslint-disable-next-line no-restricted-syntax
        for (const player of players) {
            // eslint-disable-next-line no-await-in-loop
            yield removePlayer(player.id);
        }
        setPreviousSelectedPlayers(players);
        setInfoAlert({
            message: 'Игрок удален',
            visible: true,
            setCancel: setPlayersCancel,
        });
        setPlayersChanged(true);
        setSelectedPlayers([]);
    });
    const addPlayer = (player) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const playerId = player.id;
            yield addPlayerToMatch({ playerId, matchId: matchId || '' });
            setPlayersChanged(true);
        }
        catch (e) {
            if (e) {
                try {
                    const response = yield createPlayer({
                        realName: player.player.realName,
                        gameName: player.player.gameName,
                    });
                    yield addPlayer(response);
                }
                catch (error) {
                    console.error('AddPlayerToMatch createPlayer error', error.response);
                }
            }
        }
    });
    const getImmunityAction = (playerId, immunity, reason) => function () {
        return __awaiter(this, void 0, void 0, function* () {
            // console.log('MatchPlayers setImmunity', response )
            yield setPlayerImmunity({ playerId, immunity, reason });
        });
    };
    const setImmunity = (playerId, immunity, reason) => __awaiter(void 0, void 0, void 0, function* () {
        yield execAsyncAction({
            action: getImmunityAction(playerId, immunity, reason),
        });
    });
    const showImmunityReason = () => {
        setShowImmunityPopup(true);
    };
    // eslint-disable-next-line no-shadow
    const onShieldClick = (players, reason) => __awaiter(void 0, void 0, void 0, function* () {
        if (shieldCancel) {
            // eslint-disable-next-line no-restricted-syntax
            for (const player of players) {
                // eslint-disable-next-line no-await-in-loop
                yield setImmunity(player.id, player.state.immunity, 0);
            }
            setPreviousSelectedPlayers([]);
        }
        else {
            // eslint-disable-next-line no-restricted-syntax
            for (const player of players) {
                // eslint-disable-next-line no-await-in-loop
                yield setImmunity(player.id, !player.state.immunity, reason);
            }
            setPreviousSelectedPlayers(players);
            setInfoAlert({
                message: 'Иммунитет обновлен',
                visible: true,
                setCancel: setShieldCancel,
            });
        }
        setImmunityReason(null);
        setShowImmunityPopup(false);
        setShieldCancel(false);
        setPlayersChanged(true);
        setSelectedPlayers([]);
    });
    const onImmunityReasonSelect = (reason) => __awaiter(void 0, void 0, void 0, function* () {
        console.log(reason);
        setImmunityReason(reason);
        yield onShieldClick(selectedPlayers, reason);
    });
    const getPaymentAction = (playerId, paymentType, amount, parentPayment) => function () {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield setPaymentMethod({
                playerId,
                paymentType,
                amount,
                parentPayment,
            });
            setChanged(true);
        });
    };
    const changePaymentMethod = (playerId, paymentType, amount, parentPayment) => __awaiter(void 0, void 0, void 0, function* () {
        yield execAsyncAction({
            action: getPaymentAction(playerId, paymentType, amount, parentPayment),
            final: () => __awaiter(void 0, void 0, void 0, function* () {
                yield getPlayers();
            }),
        });
    });
    const handleCloseEditingPlayerPopup = () => {
        setIsEditingPlayerPopupShown(false);
        setEditingPlayer(null);
    };
    const handleUpdatePlayerNames = ({ id, realName, gameName, }) => __awaiter(void 0, void 0, void 0, function* () {
        yield execAsyncAction({
            action: () => updatePlayerNames({ id, realName, gameName }),
            final: () => __awaiter(void 0, void 0, void 0, function* () {
                yield getPlayers();
            }),
        });
    });
    const onPaymentSubmit = (values, actions) => __awaiter(void 0, void 0, void 0, function* () {
        if (values.payment_method === EPaymentType.PAID_BY_OTHER_PLAYER) {
            yield changePaymentMethod(values.playerId, EPaymentType.PAID_BY_OTHER_PLAYER, 0, values.paymentId);
        }
        else {
            yield changePaymentMethod(values.playerId, values.payment_method, values.amount || 0, '');
        }
        setPlayersChanged(true);
    });
    const onPlayerRowClick = (player, e) => {
        e.stopPropagation();
        e.preventDefault();
        // console.log('MatchPlayers onPlayerRowClick', (e.target as any).tagName )
        if (e.target.tagName === 'SELECT')
            return;
        const index = selectedPlayers.indexOf(player);
        if (index >= 0) {
            selectedPlayers.splice(index, 1);
            setSelectedPlayers([...selectedPlayers]);
        }
        else {
            setSelectedPlayers([...selectedPlayers, player]);
        }
    };
    const onAjustOrderClick = () => {
        setAdjustOrder(true);
    };
    const onCloseAjustOrderClick = () => {
        orderSet();
        setAdjustOrder(false);
    };
    useEffect(() => {
        if (shieldCancel) {
            onShieldClick(previousSelectedPlayers, 0);
        }
    }, [shieldCancel]);
    useEffect(() => {
        getPlayers();
        getPayers();
    }, [matchId]);
    useEffect(() => {
        setDisabled(selectedPlayers.length > 0);
    }, [selectedPlayers.length > 0]);
    useEffect(() => {
        if (playersCancel) {
            // eslint-disable-next-line no-restricted-syntax
            for (const player of previousSelectedPlayers) {
                addPlayer(player);
            }
        }
    }, [playersCancel]);
    useEffect(() => {
        if (playersChanged || changed) {
            getPlayers();
            getPayers();
            setPlayersChanged(false);
            setChanged(false);
            orderSet();
        }
    }, [playersChanged, changed]);
    const onDragEnd = (result) => __awaiter(void 0, void 0, void 0, function* () {
        if (!result.destination)
            return;
        if (!matchId)
            return; // <-- добавил проверку
        setDragLoading(true);
        const newPlayers = Array.from(players);
        const [movedPlayer] = newPlayers.splice(result.source.index, 1);
        newPlayers.splice(result.destination.index, 0, movedPlayer);
        setPlayers(newPlayers);
        const playersOrder = newPlayers.map((p) => p.id);
        try {
            yield setPlayersOrder({ matchId, data: playersOrder });
            const updatedPlayers = yield loadPlayersInMatch(matchId);
            if (updatedPlayers) {
                setPlayers(updatedPlayers);
            }
            console.log('Порядок игроков успешно сохранён на сервере');
        }
        catch (error) {
            console.error('Ошибка при сохранении порядка игроков:', error);
        }
        finally {
            setDragLoading(false);
            setSelectedPlayers([]);
        }
    });
    // добавил функцию для dnd сортировки
    // Helper to check if player has unknown source
    const isUnknownSource = (playerId) => {
        return unknownSourcePlayerIds.includes(playerId);
    };
    if (isLoading) {
        return _jsx(TableSkeleton, { rows: 8, columns: 7 });
    }
    return (_jsx(_Fragment, { children: players.length ? (_jsxs(_Fragment, { children: [(adjustOrder || forceAdjustWindowOpened) && (_jsx(ModalNew, Object.assign({ onClose: onCloseAjustOrderClick, close: true }, { children: _jsx(AjustPlayersOrder, { players: players, matchId: matchId, setPlayersChanged: setPlayersChanged, onClose: onCloseAjustOrderClick }) }))), infoAlert.visible && (_jsx(AlertsNew, { message: infoAlert.message, setVisible: setInfoAlert, setCancel: infoAlert.setCancel })), showImmunityPopup && (_jsx(ModalNew, Object.assign({ onClose: () => setShowImmunityPopup(false), close: true }, { children: _jsx(ImmunityReason, { onSubmit: (reason) => onImmunityReasonSelect(reason.reason) }) }))), isEditingPlayerPopupShown && (_jsx(ModalNew, Object.assign({ onClose: handleCloseEditingPlayerPopup, close: true }, { children: _jsx(PlayerNameEditing, { onClose: handleCloseEditingPlayerPopup, player: editingPlayer, onSubmit: handleUpdatePlayerNames }) }))), selectedPlayers.length > 0 && (_jsx(TableHeaderContainer, { children: _jsxs(TableHeader, { children: [_jsx(Button, { startIcon: _jsx(DeleteIcon, {}), onClick: () => onRemovePlayerClick(selectedPlayers) }), _jsx(Delimiter, { right: "5px" }), _jsx(Button, { startIcon: _jsx(ShieldIcon, {}), onClick: () => setShowImmunityPopup(true) })] }) })), _jsxs("div", Object.assign({ style: { position: 'relative' } }, { children: [dragLoading && (_jsx("div", Object.assign({ style: {
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                zIndex: 100,
                                backgroundColor: 'rgba(255, 255, 255, 0.6)',
                                padding: '20px',
                                borderRadius: '8px',
                            } }, { children: _jsx(Typography, Object.assign({ style: {
                                    color: '#292C2E',
                                }, variant: "body1" }, { children: "\u041E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u043F\u043E\u0440\u044F\u0434\u043A\u0430..." })) }))), _jsx(TableContainer, Object.assign({ sx: { width: '100%' }, component: Paper }, { children: _jsx(DragDropContext, Object.assign({ onDragEnd: onDragEnd }, { children: _jsx(Droppable, Object.assign({ droppableId: "players-table" }, { children: (provided) => (_jsxs(Table, Object.assign({ "aria-label": "customized table" }, provided.droppableProps, { ref: provided.innerRef }, { children: [_jsx(TableHead, { children: _jsxs(TableRow, { children: [_jsx(TableCell, { style: {
                                                                padding: '0',
                                                            } }), _jsx(TableCell, Object.assign({ variant: "head", align: "center" }, { children: "\u2116" })), _jsx(TableCell, Object.assign({ variant: "head", align: "left" }, { children: "\u0418\u0433\u0440\u043E\u043A" })), _jsx(TableCell, Object.assign({ variant: "head", align: "center" }, { children: "\u041A\u0430\u043D\u0430\u043B" })), _jsx(TableCell, Object.assign({ variant: "head", align: "center" }, { children: "\u041A\u043E\u043B-\u0432\u043E \u0438\u0433\u0440" })), _jsx(TableCell, Object.assign({ variant: "head", align: "center" }, { children: "\u0417\u0430\u043C\u0435\u043D\u0430 \u043B\u0438\u0446" })), _jsx(TableCell, Object.assign({ variant: "head", align: "center" }, { children: "\u0421\u043F\u043E\u0441\u043E\u0431 \u043E\u043F\u043B\u0430\u0442\u044B" }))] }) }), _jsxs(TableBody, { children: [players.map((player, index) => (_jsx(Draggable, Object.assign({ draggableId: player.id, index: index }, { children: (provided, snapshot) => (_jsxs(TableRow, Object.assign({ ref: provided.innerRef }, provided.draggableProps, { hover: true, selected: selectedPlayers.includes(player), onClick: (e) => onPlayerRowClick(player, e) }, { children: [_jsx(TableCell, Object.assign({ style: {
                                                                        padding: '0',
                                                                    }, variant: "body", align: "center" }, { children: _jsx("div", Object.assign({}, provided.dragHandleProps, { style: {
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            justifyContent: 'center',
                                                                            height: '100%',
                                                                            cursor: 'grab',
                                                                        } }, { children: _jsxs("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", className: "lucide lucide-grip-vertical" }, { children: [_jsx("circle", { cx: "9", cy: "12", r: "1" }), _jsx("circle", { cx: "9", cy: "5", r: "1" }), _jsx("circle", { cx: "9", cy: "19", r: "1" }), _jsx("circle", { cx: "15", cy: "12", r: "1" }), _jsx("circle", { cx: "15", cy: "5", r: "1" }), _jsx("circle", { cx: "15", cy: "19", r: "1" })] })) })) })), _jsxs(TableCell, Object.assign({ variant: "body", align: "center" }, { children: [player.positionNumber, player.state.immunity && _jsx(ShieldIcon, {})] })), _jsx(TableCell, Object.assign({ variant: "body", align: "left" }, { children: _jsxs(Box, Object.assign({ sx: { display: 'flex', alignItems: 'center', gap: '8px' } }, { children: [_jsxs(Box, { children: [_jsx(Typography, Object.assign({ variant: "body2", sx: { fontWeight: 500 } }, { children: player.player.realName })), _jsx(Typography, Object.assign({ variant: "caption", sx: { color: 'text.secondary' } }, { children: player.player.gameName }))] }), _jsx(Button, { size: "small", startIcon: _jsx(DriveFileRenameOutlineIcon, {}), onClick: (event) => {
                                                                                    event.stopPropagation();
                                                                                    setIsEditingPlayerPopupShown(true);
                                                                                    setEditingPlayer(player);
                                                                                }, sx: { minWidth: 'auto', padding: '4px' } })] })) })), _jsx(TableCell, Object.assign({ variant: "body", align: "center" }, { children: _jsx(Chip, { label: isUnknownSource(player.player.id) ? 'Неизвестен' : 'Известен', color: isUnknownSource(player.player.id) ? 'error' : 'success', size: "small", variant: "filled" }) })), _jsx(TableCell, Object.assign({ variant: "body", align: "center" }, { children: player.player.gamesCount })), _jsx(TableCell, Object.assign({ variant: "body", align: "center" }, { children: player.player.swaps.pending > 0
                                                                        ? `В процессе, (${player.player.swaps.pending})`
                                                                        : 'Готово' })), _jsx(TableCell, Object.assign({ variant: "body", align: "center" }, { children: _jsx(Payment, { player: player, onPaymentSubmit: onPaymentSubmit, players: payers.filter((p) => {
                                                                            var _a, _b;
                                                                            return p.id !== player.id &&
                                                                                p.payment !== null &&
                                                                                ((_a = p.payment) === null || _a === void 0 ? void 0 : _a.method) !== EPaymentType.PAID_BY_OTHER_PLAYER &&
                                                                                ((_b = p.payment) === null || _b === void 0 ? void 0 : _b.amount) > 0;
                                                                        }) }) }))] }))) }), player.id))), provided.placeholder] })] }))) })) })) }))] }))] })) : (_jsxs(_Fragment, { children: [_jsx(Typography, Object.assign({ variant: "h4" }, { children: "\u0418\u0433\u0440\u043E\u043A\u0438" })), _jsx(Delimiter, { top: "20px" }), _jsx(Typography, Object.assign({ sx: { width: 700 }, variant: "h4" }, { children: "\u0418\u0433\u0440\u043E\u043A\u0438 \u043D\u0435 \u0432\u044B\u0431\u0440\u0430\u043D\u044B" }))] })) }));
};
